module.exports = __webpack_public_path__ + "img/plus-gray.330ad3a9.svg";